import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
  IonItem,
  IonLabel,
  IonInput,
  IonText,
  IonIcon,
  IonButton,
  IonSpinner
} from '@ionic/react';
import {
  arrowBackOutline,
  homeOutline,
  informationCircleOutline,
  keyOutline,
  personOutline
} from 'ionicons/icons';
import HMSHome from './HMSHome';

const HMSHomeTestHarness = () => {
  const history = useHistory();
  const [auth_token, setAuthToken] = useState('');
  const [user_id, setUserId] = useState('');
  const [showHMSHome, setShowHMSHome] = useState(false);
  const [error, setError] = useState(null);

  // Load from localStorage on mount
  useEffect(() => {
    const storedAuthToken = localStorage.getItem('auth_token');
    const storedUserId = localStorage.getItem('user_id');
    
    if (storedAuthToken && storedUserId) {
      setAuthToken(storedAuthToken);
      setUserId(storedUserId);
      setShowHMSHome(true);
    }
  }, []);

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    if (auth_token.trim() && user_id.trim()) {
      localStorage.setItem('auth_token', auth_token);
      localStorage.setItem('user_id', user_id);
      setShowHMSHome(true);
      setError(null);
    } else {
      setError('Please provide both auth token and user ID');
    }
  };

  // Handle reset
  const handleReset = () => {
    setAuthToken('');
    setUserId('');
    setShowHMSHome(false);
    setError(null);
    localStorage.removeItem('auth_token');
    localStorage.removeItem('user_id');
  };

  if (showHMSHome && auth_token && user_id) {
    return (
      <>
        <IonPage>
          <IonHeader>
            <IonToolbar>
              <IonButton fill="clear" slot="start" onClick={handleReset}>
                <IonIcon icon={arrowBackOutline} />
              </IonButton>
              <IonTitle>HMS Home - Test Mode</IonTitle>
              <IonButton fill="clear" slot="end" onClick={handleReset}>
                Reset
              </IonButton>
            </IonToolbar>
          </IonHeader>
          <IonContent>
            <HMSHome />
          </IonContent>
        </IonPage>
      </>
    );
  }

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButton fill="clear" slot="start" onClick={() => history.goBack()}>
            <IonIcon icon={arrowBackOutline} />
          </IonButton>
          <IonTitle>HMS Home Test Harness</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent>
        <div style={{ padding: '16px' }}>
          <IonCard>
            <IonCardHeader>
              <IonCardTitle>
                <IonIcon icon={homeOutline} />
                HMS Home Test Harness
              </IonCardTitle>
            </IonCardHeader>
            <IonCardContent>
              <IonText>
                <p>
                  This test harness allows you to test the HMS Home page with real user data.
                </p>
                <p>
                  Enter your auth token and user ID to view tasks due today and older for that user.
                </p>
              </IonText>
            </IonCardContent>
          </IonCard>

          <IonCard>
            <IonCardHeader>
              <IonCardTitle>Authentication</IonCardTitle>
            </IonCardHeader>
            <IonCardContent>
              <form onSubmit={handleSubmit}>
                <IonItem>
                  <IonIcon icon={keyOutline} slot="start" />
                  <IonLabel position="stacked">Auth Token *</IonLabel>
                  <IonInput
                    value={auth_token}
                    onIonInput={e => setAuthToken(e.detail.value)}
                    placeholder="Enter your auth token"
                    type="text"
                    clearInput
                  />
                </IonItem>

                <IonItem>
                  <IonIcon icon={personOutline} slot="start" />
                  <IonLabel position="stacked">User ID *</IonLabel>
                  <IonInput
                    value={user_id}
                    onIonInput={e => setUserId(e.detail.value)}
                    placeholder="Enter your user ID"
                    type="text"
                    clearInput
                  />
                </IonItem>

                {error && (
                  <IonCard color="danger" style={{ marginTop: '16px' }}>
                    <IonCardContent>
                      <IonText color="light">
                        <IonIcon icon={informationCircleOutline} />
                        {error}
                      </IonText>
                    </IonCardContent>
                  </IonCard>
                )}

                <div style={{ marginTop: '24px', textAlign: 'center' }}>
                  <IonButton expand="block" type="submit">
                    <IonIcon icon={homeOutline} slot="start" />
                    Load HMS Home
                  </IonButton>
                </div>
              </form>
            </IonCardContent>
          </IonCard>

          <div style={{ textAlign: 'center', marginTop: '24px' }}>
            <IonButton
              expand="block"
              fill="outline"
              onClick={() => history.push('/hms_home')}
            >
              <IonIcon icon={homeOutline} slot="start" />
              Launch HMS Home (Manual Mode)
            </IonButton>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default HMSHomeTestHarness;


